module.exports = __webpack_public_path__ + "img/icon-empty-state-swarm.2be12c33.svg";